import { apiSliceV2 } from '../../apiSlice';

export const energyGroupsApiSlice = apiSliceV2.injectEndpoints({
  tagTypes: ['EnergyGroup'],
  endpoints: (builder) => ({
    getEnergyGroups: builder.query({
      query: (accountId) => ({
        url: `/EnergyGroups`,
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      // transformResponse: (response) => {
      // 	if (Array.isArray(response)) {
      // 		return response.map(item => item.result);
      // 	}
      // 	return [];
      // },
      providesTags: ['EnergyGroup'],
    }),
    getEnergyGroupById: builder.query({
      query: ({ energyGroupId, accountId }) => {
        return {
          url: `/EnergyGroups/${energyGroupId}`,
          headers: {
            'X-Account-Id': accountId,
          },
        };
      },
      providesTags: ['EnergyGroup'],
    }),
    getEnergyGroupsByUser: builder.query({
      query: () => ({
        url: `/EnergyGroups/User`,
      }),
      providesTags: ['EnergyGroup'],
    }),
    postEnergyGroup: builder.mutation({
      query: ({ energyGroup, accountId }) => ({
        url: `/EnergyGroups`,
        method: 'POST',
        body: energyGroup,
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      invalidatesTags: ['EnergyGroup'],
    }),
    putEnergyGroup: builder.mutation({
      query: (energyGroup) => ({
        url: `/EnergyGroups/${energyGroup.id}`,
        method: 'PUT',
        body: energyGroup,
      }),
      invalidatesTags: ['EnergyGroup'],
    }),
    deleteEnergyGroup: builder.mutation({
      query: ({ energyGroupId, accountId }) => ({
        url: `/EnergyGroups/${energyGroupId}`,
        method: 'DELETE',
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      invalidatesTags: ['EnergyGroup'],
    }),
    putEnergyGroupOptions: builder.mutation({
      query: ({ accountId, energyGroupId, options }) => ({
        url: `/EnergyGroups/${energyGroupId}/Options`,
        method: 'PUT',
        body: options,
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      invalidatesTags: ['EnergyGroup'],
    }),
  }),
});

export const {
  useGetEnergyGroupsQuery,
  useLazyGetEnergyGroupsQuery,
  useGetEnergyGroupByIdQuery,
  useLazyGetEnergyGroupByIdQuery,
  useGetEnergyGroupsByUserQuery,
  useLazyGetEnergyGroupsByUserQuery,
  usePostEnergyGroupMutation,
  usePutEnergyGroupMutation,
  useDeleteEnergyGroupMutation,
  usePutEnergyGroupOptionsMutation,
} = energyGroupsApiSlice;
